{
  "tabs": {
    "chat": "Obrolan",
    "reminders": "Pangeling",
    "calendar": "Kalender",
    "settings": "Setelan"
  },
  "common": {
    "cancel": "Batal",
    "save": "Simpen",
    "confirm": "Konfirmasi",
    "delete": "Busak",
    "back": "Bali",
    "close": "Tutup",
    "edit": "Sunting",
    "search": "Golek",
    "all": "Kabeh",
    "loading": "Ngundhuh...",
    "error": "Ana kesalahan",
    "notFound": "Ora ketemu",
    "tryAgain": "Coba maneh",
    "retry": "Coba maneh",
    "undo": "Batalake",
    "pullToRefresh": "Tarik kanggo nganyari",
    "justNow": "bar iki"
  },
  "auth": {
    "welcome": "Sugeng rawuh ing FishMemory",
    "tagline": "Asisten pangeling WhatsApp-mu, saiki ana ing kanthongmu.",
    "subtitle": "Asisten pangeling WhatsApp-mu, saiki ana ing kanthongmu.",
    "phoneLabel": "Nomor WhatsApp-mu",
    "phoneHint": "Kita bakal ngirim kode verifikasi liwat WhatsApp",
    "invalidPhone": "Mangga lebokna nomer telpon sing bener",
    "continue": "Terusake",
    "enterPhone": "Lebokna nomer WhatsApp-mu",
    "phonePlaceholder": "Nomer telpon",
    "sendCode": "Kirim Kode",
    "verifyTitle": "Verifikasi nomermu",
    "otpSentTo": "Kode 6 digit wis dikirim menyang {{phone}} liwat WhatsApp",
    "enterFullCode": "Mangga lebokna kabeh 6 digit",
    "invalidOtp": "Kode ora bener. Coba maneh.",
    "otpFailed": "Gagal ngirim kode. Coba maneh.",
    "otpResent": "Kode dikirim maneh",
    "resendIn": "Kirim maneh ing {{seconds}}d",
    "resendCode": "Kirim maneh kode",
    "enterOtp": "Lebokna kode sing dikirim menyang WhatsApp-mu",
    "verify": "Verifikasi",
    "resend": "Kirim maneh kode",
    "wrongNumber": "Nomer salah?",
    "backToPhone": "Bali menyang nomer",
    "editPhone": "Sunting nomer telpon",
    "error": "Kesalahan",
    "setupTitle": "Ayo disetel",
    "setupSubtitle": "Sampeyan bisa ngganti kapan wae ing Setelan",
    "namePlaceholder": "Jenengmu",
    "letsGo": "Rampungake setelan",
    "skipForNow": "Langkahi saiki"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Ketik pesen...",
    "inputPlaceholder": "Ketik pesen...",
    "typing": "FishMemory ngetik...",
    "online": "Online",
    "connecting": "Nyambung...",
    "reconnecting": "Nyambung maneh...",
    "offline": "Offline",
    "empty": "Miwiwiti obrolan",
    "emptyHint": "Gawe pangeling, priksa jadwal, utawa njaluk bantuan.",
    "emptyAction": "Kirim pangeling conto",
    "actions": "Tindakan obrolan",
    "keep": "Simpen pesen",
    "clearTitle": "Bersihake obrolan",
    "clearConfirm": "Busak kabeh pesen saka piranti iki? Iki ora bisa dibalekake.",
    "clear": "Bersihake obrolan",
    "optionSelected": "Dipilih: {{label}}",
    "sendingSelection": "Kirim...",
    "connectionLost": "Nyambung maneh..."
  },
  "reminders": {
    "title": "Pangelingku",
    "active": "Aktif",
    "today": "Dina iki",
    "thisWeek": "Minggu iki",
    "history": "Riwayat",
    "items": "item",
    "emptyTitle": "Durung ana pangeling",
    "emptySubtitle": "Gawe saka obrolan lan bakal katon ing kene.",
    "emptyAction": "Bukak obrolan",
    "filterActive": "Aktif",
    "filterToday": "Dina iki",
    "filterWeek": "Minggu iki",
    "filterHistory": "Riwayat",
    "emptyState": "Durung ana pangeling. Miwiti obrolan!",
    "swipeDone": "Rampung",
    "swipeSnooze": "Tunda",
    "swipeDelete": "Busak",
    "search": "Golek pangeling...",
    "upcoming": "Mendatang",
    "completed": "Rampung",
    "overdue": "Telat",
    "tomorrow": "Sesuk",
    "synced": "Disinkron {{value}}",
    "swipeHint": "Geser pangeling kanggo tindakan luwih",
    "noResults": "Ora ana pangeling sing cocog",
    "noResultsHint": "Coba tembung liya utawa resikake golek",
    "deleteAllFailed": "Gagal mbusak kabeh pangeling"
  },
  "calendar": {
    "title": "Kalender",
    "today": "Dina iki",
    "tomorrow": "Sesuk",
    "completed": "rampung",
    "noEvents": "Ora ana jadwal",
    "noEventsSubtitle": "Pilih tanggal kanggo ndeleng pangeling lan acara kalender.",
    "googleEvent": "Google Calendar",
    "legendActive": "Aktif",
    "legendRecurring": "Baleni",
    "legendDone": "Rampung",
    "legendGoogle": "Google",
    "previousMonth": "Sasi kepungkur",
    "nextMonth": "Sasi sabanjure",
    "previousYear": "Taun kepungkur",
    "nextYear": "Taun sabanjure",
    "goToToday": "Mlebu dina iki",
    "all": "Kabeh",
    "active": "Aktif",
    "done": "Rampung",
    "paused": "Mandheg"
  },
  "settings": {
    "title": "Setelan",
    "profile": "Profil",
    "name": "Jeneng Tampilan",
    "enterName": "Lebokna jenengmu",
    "language": "Basa",
    "uiLanguage": "Basa aplikasi",
    "uiLanguageHelp": "Ngganti UI aplikasi, label kalender, lan arah tata letak mung ing piranti iki.",
    "serverLanguage": "Basa obrolan",
    "serverLanguageHelp": "Ngganti basa sing digunakake server kanggo balesan lan pesen pangeling akunmu.",
    "timezone": "Zona wektu",
    "currentTimezone": "Zona wektu saiki",
    "timezoneHelp": "Kabeh wektu pangeling ditampilake nganggo zona wektu iki.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "Simpen zona wektu",
    "timezoneSaved": "Zona wektu dianyari",
    "detect": "Deteksi",
    "detectFailed": "Gagal ndeteksi zona wektu",
    "autoDetect": "Deteksi otomatis saka GPS",
    "notifications": "Notifikasi",
    "notificationsHelp": "Pangeling tindak lanjut ngontrol tandha baleni sawise pangeling dikirim. Ijin notifikasi piranti isih diatur ing setelan telponmu.",
    "pushEnabled": "Notifikasi Push",
    "autoDoneOnFire": "Otomatis rampung nalika aktif",
    "autoDoneOnFireDesc": "Yen mati, pangeling tetep aktif nganti sampeyan nandhani rampung.",
    "googleCalendar": "Google Calendar",
    "google": "Google Calendar",
    "googleConnected": "Nyambung",
    "googleDisconnected": "Ora nyambung",
    "googleConnectedHelp": "Pangeling anyar bisa disinkronake otomatis menyang kalendermu.",
    "googleDisconnectedHelp": "Sambungake Google Calendar supaya pangeling lan acara selaras.",
    "googleConnectFailed": "Gagal nyambung Google Calendar",
    "connected": "Nyambung",
    "disconnected": "Ora nyambung",
    "connect": "Sambungake",
    "disconnect": "Putusake",
    "autoSync": "Sinkron otomatis pangeling anyar",
    "autosync": "Sinkron otomatis pangeling anyar",
    "subscription": "Langganan",
    "trialUsed": "Coba: {{used}}/{{total}} wis digunakake",
    "trialStatus": "Coba kasedhiya",
    "activeStatus": "Langganan aktif",
    "expiredStatus": "Langganan kadaluwarsa",
    "unsubscribedStatus": "Ora langganan",
    "about": "Babagan",
    "version": "Versi",
    "logout": "Metu",
    "logoutTitle": "Metu",
    "logoutConfirm": "Apa sampeyan yakin pengin metu?",
    "noName": "Durung ana jeneng",
    "serverConnection": "Sambungan server",
    "serverUrl": "URL server",
    "serverEdit": "Sunting",
    "saveReconnect": "Simpen lan sambung maneh",
    "resetDefault": "Reset standar",
    "invalidServerUrlTitle": "URL server ora valid",
    "invalidServerUrlMessage": "Lebokna URL server http utawa https sing valid, contone https://example.com",
    "uiLanguageChangeFailed": "Gagal ngganti basa aplikasi. Coba maneh.",
    "serverLanguageChangeFailed": "Gagal ngganti basa obrolan. Coba maneh.",
    "timezoneChangeFailed": "Gagal ngganti zona wektu. Coba maneh.",
    "autoSyncChangeFailed": "Gagal nganyari sinkron otomatis. Coba maneh.",
    "nameChangeFailed": "Gagal nganyari jeneng tampilan. Coba maneh.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "Rincian pangeling",
    "editTime": "Sunting Wektu",
    "rename": "Ganti jeneng",
    "snooze": "Tunda",
    "snooze15": "Tunda 15 menit",
    "pause": "Mandheg",
    "pauseReminder": "Mandheg pangeling",
    "resume": "Lanjutake",
    "resumeReminder": "Lanjutake pangeling",
    "skip": "Langkahi Sabanjure",
    "skipOccurrence": "Langkahi kedadeyan iki",
    "syncGoogle": "Sinkron karo Google",
    "delete": "Busak",
    "deleteTitle": "Busak Pangeling",
    "deleteConfirm": "Pangeling iki bakal dibusak permanen.",
    "deleteRecurringTitle": "Busak Pangeling Baleni",
    "deleteRecurringMessage": "Apa sampeyan pengin langkahi kedadeyan iki utawa busak kabeh seri?",
    "deleteThisOccurrence": "Langkahi Kedaden Iki",
    "deleteEntireSeries": "Busak Kabeh Seri",
    "done": "Rampung",
    "markDone": "Tandhani rampung",
    "undo": "Balekake",
    "undoPrompt": "Perlu aktif maneh? Balekake saiki.",
    "recurring": "Baleni",
    "nextRun": "Lari sabanjure",
    "oneTime": "Siji wektu",
    "pending": "Ngenteni",
    "sent": "Kirim",
    "paused": "Mandheg",
    "active": "Aktif",
    "snoozed": "Ditunda",
    "localTime": "Ditampilake ing wektu lokalmu",
    "recurrence": "Baleni",
    "created": "Digawe",
    "tags": "Tag",
    "fireCount": "Kapindho aktif",
    "actions": "Tindakan",
    "none": "Ora ana",
    "snoozeFailed": "Gagal nundha pangeling",
    "pauseFailed": "Gagal mandheg pangeling",
    "resumeFailed": "Gagal nerusake pangeling",
    "skipFailed": "Gagal langkahi pangeling",
    "doneFailed": "Gagal nandhani pangeling rampung",
    "undoFailed": "Gagal mbalekake status pangeling",
    "deleteFailed": "Gagal mbusak pangeling",
    "rescheduleTitle": "Ngatur maneh?",
    "rescheduleMsg": "Pangeling iki wis telat. Apa sampeyan pengin ngatur maneh?",
    "reschedule15": "Ing 15 menit",
    "reschedule60": "Ing 1 jam",
    "keepOverdue": "Tetep kaya saiki"
  },
  "onboarding": {
    "slide1Title": "Sugeng rawuh ing FishMemory",
    "slide1Sub": "Asisten pangeling pribadimu — didhukung dening WhatsApp lan digawe kanggo kanthongmu.",
    "slide2Title": "Mung Obrolan Alami",
    "slide2Sub": "Ketik pangeling kaya sing sampeyan pikirake: \"Elingake aku nelpon ibu sesuk jam 3 sore\" — kita sing ngurus liyane.",
    "slide3Title": "Aja Kelewatan Apa-apa",
    "slide3Sub": "Entuk notifikasi tepat wektu, atur nganggo tag, lan tetep ngatur kabeh sing penting.",
    "getStarted": "Miwiwiti",
    "next": "Sabanjure",
    "firstReminderTitle": "Gawe pangeling pisananmu!",
    "firstReminderHint": "Coba ketik kaya iki:",
    "firstReminderExample": "Elingake aku ngombe banyu sesuk jam 9 esuk",
    "gotIt": "Ngerti!",
    "notifRationaleTitle": "Tetep Tepat Wektu",
    "notifRationaleBody": "FishMemory butuh notifikasi kanggo ngelingake sampeyan tepat wektu. Sampeyan mung bakal nampa tandha kanggo pangeling sing digawe.",
    "notifRationaleAllow": "Aktifake Notifikasi",
    "notifRationaleLater": "Mungkin Mengko",
    "swipeHint": "Geser tengen kanggo tindakan cepet →",
    "calendarDragHint": "Seret kanggo ngembangake ↕"
  }
}
